(function () {
    if (window.__socialProofHasFired) {
      return;
    }

    window.Branch = window.Branch || {};
    window.Branch.socialProof = window.Branch.socialProof || {};
    window.Branch.socialProof.sliders = window.Branch.socialProof.sliders || {};
    window.__socialProofHasFired = true;

    function initTestimonialSlider(socialProofSection, parent){
        let parentId = parent.getAttribute('id');
        let only_logos = socialProofSection.getAttribute('data-only-logos') == 'true';
        let enable_autoscroll = socialProofSection.getAttribute('data-enable-autoscroll') == 'true';
        let autoscroll_interval = 1000 * parseInt(socialProofSection.getAttribute('data-autoscroll-interval'));

        let autoplay = !enable_autoscroll ? false : {delay: autoscroll_interval, disableOnInteraction: true}
        if(!only_logos){
            window.Branch.socialProof.sliders[`testimonial_text_swiper_${parentId}`] = new Swiper(`#${parentId} .testimonial-container`, {
                spaceBetween: 0,
                loop: true,
                loopedSlides: 7,
                initialSlide: 0,
                autoHeight: true
            }); 
        }
        
        window.Branch.socialProof.sliders[`logo_text_swiper_${parentId}`] = new Swiper(`#${parentId} .logo-container-swiper`, {
            spaceBetween: 0,
            centeredSlides: true,
            slidesPerView: 'auto',
            autoplay: autoplay,
            touchRatio: 0.2,
            slideToClickedSlide: true,
            loop: true,
            loopedSlides: 7
        });


        if(!only_logos) {
            window.Branch.socialProof.sliders[`logo_text_swiper_${parentId}`].controller.control = window.Branch.socialProof.sliders[`testimonial_text_swiper_${parentId}`];
            window.Branch.socialProof.sliders[`testimonial_text_swiper_${parentId}`].controller.control = window.Branch.socialProof.sliders[`logo_text_swiper_${parentId}`];
        }
    }

    window.Branch.socialProof.socialProofInitOnLoad = function(){
        let socialProofSections = document.querySelectorAll('.section-social-proof:not([data-initialized="true"])');
        socialProofSections.forEach((socialProofSection) => {
            let parent = socialProofSection.closest('.shopify-section');
            socialProofSection.setAttribute('data-initialized', true);
            initTestimonialSlider(socialProofSection, parent);
        })  
    }

    if (document.readyState === "complete") {
        window.Branch.socialProof.socialProofInitOnLoad(); 
    } else {
        window.addEventListener("load", window.Branch.socialProof.socialProofInitOnLoad);
    }
  })();
